import { GenericCheckboxFilter, GenericCheckboxCategoryFilter } from '../../../shared/filters/generic-checkbox-category-filter/generic-checkbox-category-filter.model';

export class WheelShowCategoryFilter extends GenericCheckboxCategoryFilter {
  name: string;
  filters: GenericCheckboxFilter[];
  isAllChecked: boolean;

  get showFilter() {
    return (this.filters) && this.filters.length > 0;
  }

  constructor(obj?: WheelShowCategoryFilter) {
    super();
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
